"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Queries = function Queries(RestWrapper, PromisesResolver, Application) {
    _classCallCheck(this, Queries);

    this._restWrapper = RestWrapper;
    this._promisesResolver = PromisesResolver;
    this._application = Application;
};

exports["default"] = Queries;
module.exports = exports["default"];
//# sourceMappingURL=Queries.js.map


// WEBPACK FOOTER //
// ./~/ng-admin/~/admin-config/lib/Queries/Queries.js